import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-footer__inner modal-footer__inner--changing-order"
}
const _hoisted_2 = {
  key: 1,
  class: "modal-footer__inner"
}

import { type PropType } from 'vue';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import { modalType, ModalFooterVariant, type ModalFooterVariantType, type ModalType } from './modal-type-validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalFooter',
  props: {
  type: { type: String as PropType<ModalType>, default: modalType.base },
  variant: { type: String as PropType<ModalFooterVariantType>, default: ModalFooterVariant.default },
},
  setup(__props) {



const { isSMAndDown } = useMQBreakpoints();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['modal-footer', `modal-footer--${__props.type}`, `modal-footer--${__props.variant}`])
  }, [
    (_unref(isSMAndDown))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", { itemClass: "modal-footer__item" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", { itemClass: "modal-footer__item" })
        ]))
  ], 2))
}
}

})